import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ListOrder from '../Order/ListOrder'
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import { translate } from '../../../../../utils/util';
import * as pabReplanningAction from '../../../../../actions/pabReplanningAction';
import { PERMISSIONS } from '../../../../../utils/constants';
import { checkPermission } from '../../../../../services/auth';

const PickingOrders = (props) => {
    const filterOrder = props.status?.state;
    const [aux, setAux] = useState(1);
    const [allOrders, setAllOrders] = useState(
        (filterOrder?.byFilter && filterOrder?.byFilterOrder) || !checkPermission(PERMISSIONS.Lowering.ManageLowering) || aux === 1
            ? true
            : props.filter.allOrders
    );

    useEffect(() => {
        setAux(aux + 1);
        if ((props.filter.allOrders && allOrders) || (!props.filter.allOrders && !allOrders)) {
            return;
        }

        props.filter.allOrders = allOrders;
        props.selectedFilterOrderAll(props.filter);
        return () => {
            setAux(0);
        }
        // eslint-disable-next-line
    }, []);

    const onClick = (set) => {
        setAux(aux + 1);
        setAllOrders(set);
        props.filter.allOrders = set;
        props.selectedFilterOrderAll(props.filter);
    };

    return (
        <div>
            <Breadcrumbs id="linePickingOrders" subtitles={[{ icon: "business_center", label: translate('expedition:picking.orders') }]} />
            <div style={{ marginTop: '25px', }}>
                <ListOrder data={props.orders} allOrders={aux === 1 ? true : allOrders} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        orders: state.pabReplanningReducer.orders,
        filter: state.pabReplanningReducer.filter,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectedFilterOrderAll: (filter) => {
            dispatch(pabReplanningAction.setFilter(filter));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingOrders)));

